export default __webpack_public_path__ + "static/media/20.75a3a939.png";